import * as yup from "yup";

export const useWelcomeFormValidation = () => {
  return yup.object({
    name: yup.string().required("Please enter name"),
    email: yup.string().required("Please enter email").email()
  });
};
